<section [formGroup]="stepForm">
  <div
    *ngIf="databaseServerInstances?.length"
    [attr.data-e2e]="elementsSelector.name.sqlInstanceBlock">
    <div class="row">
      <div class="col-6">
        <mbs-form-group>
          <div class="form-row align-items-end">
            <div class="col-10">
              <mbs-select
                formControlName="sqlServerInstanceName"
                (change)="resetValidStateIfChangedData()"
                [label]="'wizards:sql:sqlServerNameLabel' | i18next"
                [appendTo]="'.modal-content'"
                [bindValue]="'Name'"
                [bindLabel]="'Name'"
                [items]="databaseServerInstances"
                [id]="'db-instances-select'"
                [clearable]="false"
                [attr.data-e2e]="elementsSelector.name.sqlInstanceControl"
                [searchable]="false"></mbs-select>
            </div>
            <div class="col-2">
              <mbs-button
                icon="fa fa-pencil"
                [container]="'body'"
                [ngbTooltip]="'wizards:sql:editSQLServerNameLabel' | i18next"
                (click)="editSQLServerNameClickHandler()"></mbs-button>
            </div>
          </div>
        </mbs-form-group>

        <mbs-form-group>
          <mbs-select
            formControlName="authenticationType"
            (change)="resetValidStateIfChangedData()"
            [label]="'wizards:sql:sqlAuthTypeLabel' | i18next"
            [appendTo]="'.modal-content'"
            [bindValue]="'value'"
            [bindLabel]="'label'"
            [items]="SQLServerAuthTypes"
            [id]="'auth-type-select'"
            [clearable]="false"
            [attr.data-e2e]="elementsSelector.name.authTypeControl"
            [searchable]="false"></mbs-select>
        </mbs-form-group>

        <mbs-form-group>
          <mbs-input
            formControlName="userName"
            name="userName"
            (change)="resetValidStateIfChangedData()"
            [attr.data-e2e]="elementsSelector.name.sqlUserNameInput"
            [id]="'user-name-input'"
            [label]="authTypeIsWindows ? ('wizards:sql:sqlUserNameLabel' | i18next) : ('wizards:sql:sqlLoginLabel' | i18next)"
            [validationWhitespace]="true"></mbs-input>
        </mbs-form-group>

        <mbs-form-group>
          <mbs-input
            #sqlPassField
            formControlName="password"
            name="password"
            (change)="resetValidStateIfChangedData()"
            [attr.data-e2e]="elementsSelector.name.sqlPasswordInput"
            [label]="'wizards:sql:sqlPasswordLabel' | i18next"
            [id]="'sql-password-input'"
            [autocomplete]="'off'"
            [type]="passwordInputType"
            (blur)="passwordBlurHandler($event)"
            (focus)="passwordFocusHandler($event)"
            (buttonClick)="changePasswordType()"
            [appendButtons]="[
              {
                icon: passwordInputType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash',
                id: 'changeTypeSQLPassword',
                disabled: stepForm.get('password')?.value === initialPass || stepForm?.get('password')?.disabled,
                type: 'secondary'
              }
            ]">
          </mbs-input>
        </mbs-form-group>
      </div>
    </div>

    <mbs-form-group class="mt-4">
      <mbs-checkbox
        formControlName="checkIsSysAdmin"
        (change)="resetValidStateIfChangedData()"
        [attr.data-e2e]="elementsSelector.name.checkIsSysAdmin"
        [label]="(this.isRestoreDB ? 'wizards:sql.sqlSysAdminRestoreLabel' : 'wizards:sql.sqlSysAdminLabel') | i18next"
        [id]="'sql-check-sys-admin-checkbox'">
        <ng-container appendLabel>
          <span
            class="fa fa-info-circle ml-2 cursor-help text-info"
            container="body"
            placement="left-bottom auto"
            tooltipClass="tooltip-lg text-start"
            [ngbTooltip]="
              (this.isRestoreDB ? 'wizards:sql.sqlSysAdminRestoreDescription' : 'wizards:sql.sqlSysAdminDescription') | i18next
            "></span>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-checkbox
        formControlName="useSecureConnection"
        [label]="'wizards:sql:sqlSecureConnectionLabel' | i18next"
        [id]="'sql-use-secure-connection-checkbox'">
        <ng-container appendLabel>
          <span
            class="fa fa-info-circle ml-2 cursor-help text-info"
            container="body"
            tooltipClass="tooltip-lg text-start"
            [ngbTooltip]="'wizards:sql:sqlSecureConnectionDescription' | i18next"></span>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>
  </div>

  <mbs-alert
    *ngIf="!databaseServerInstances?.length"
    [type]="mbsPopupType.warning"
    [icon]="true"
    class="mb-0">
    {{ 'wizards:sql.sqlNoServerInstancesAlert' | i18next }}
  </mbs-alert>
</section>

<ng-template #changeNameModal>
  <div [formGroup]="changeNameForm">
    <mbs-input
      formControlName="sqlInstanceName"
      name="sqlInstanceName"
      [label]="'wizards:sql:sqlServerNameLabel' | i18next"
      [id]="'sql-server-name-input'"
      [showRequiredMark]="false"
      [validationWhitespace]="true"></mbs-input>
  </div>
</ng-template>

<ng-template #notSysAdminModal>
  <mbs-alert
    [type]="mbsPopupType.warning"
    [icon]="true"
    class="mb-0">
    <span *ngIf="authTypeIsWindows">{{ 'wizards:sql.sqlNotSysAdminModalText' | i18next }}</span>
    <span *ngIf="!authTypeIsWindows">
      {{ 'wizards:sql.sqlNotSysAdminModalNotWindowsText' | i18next: { userName: value.userName } }}
      <a
        target="_blank"
        [helpLink]="'https://kb.msp360.com/managed-backup-service/sql-server-backup-permissions'"
        [kbMode]="true">
        {{ 'wizards:learn_more_link' | i18next }}
      </a>
    </span>
  </mbs-alert>
</ng-template>
